// @flow
// Some of the imports use $FlowFixMe because they are .tsx
import React, { useContext, useEffect, useState } from 'react';
// $FlowFixMe
import ProductCard, { ProductCardProps } from '@cat/product-card';
// $FlowFixMe
import ProductMarketingFlag from '@cat/product-marketing-flag';
// $FlowFixMe
import ProductImage from '@cat/product-image';
// $FlowFixMe
import ProductName from '@cat/product-name';
// $FlowFixMe
import DropshipDetails from '@cat/dropship-details';

// $FlowFixMe
import QuickAdd from '@cat/quick-add';
// $FlowFixMe
import { Price } from '@core-ui/product-price';
// $FlowFixMe
import ReviewRatings from '@core-ui/review-ratings';
// $FlowFixMe
import { catPriceAdapter } from '@core-ui/price-case';
import { useLocalize } from '@core-ui/localization-provider';
import { getLocationSearch, getHashParameter } from '@core-ui/url-helper';
import { BrandInfoContext } from '@core-ui/brand-info-provider';
import { Swatches } from '@core-ui/swatches';
// $FlowFixMe
import { storageHelper } from '@core-ui/utility';
// $FlowFixMe
import buildProductLink from './collaborators/build-product-link';
// $FlowFixMe
import { StarReviewStyledWrapper } from './styled/StarReviewStyledWrapper';
import { ProductPriceWrapper } from './styled/ProductPriceWrapper';
import { ProductInfoWrapper } from './styled/ProductInfoWrapper';
import { PRODUCT_GRID_REDUCED_PRICE_FLAG } from './localization-tokens';
// $FlowFixMe
import useStarRatings from '../../hooks/features/useStarRatings';
// $FlowFixMe
import useColorSwatches from '../../hooks/features/useColorSwatches';
// $FlowFixMe
import useDropship from '../../hooks/features/useDropship';
// $FlowFixMe
import useBRRedesign from '../../hooks/features/useBRRedesign';
import useProductImagery from './hooks/useProductImagery';
import {
  BreakpointContext,
  MEDIUM,
  LARGE,
  XLARGE,
} from '@core-ui/breakpoint-provider';
import PriceLine from '../product-price-line-text/PriceLine';
import { PriceLineDiv } from '../product-price-line-text/styles';

const GAP_BRANDS = ['gap', 'gapfs'];
const MARKETS = ['us', 'ca'];
const GAP_REVIEW_INITIAL_LIMIT = 5;

const SCROLLED_CID = 'scrolledCid';
const SCROLL_Y_POSITION = 'scrollYPosition';
const RATINGS_ENGAGEMENT = 'starRatingsEngagement';
const DROPSHIP_TEXT = 'DROPSHIP';

const isStarRatingsEnabled = (shouldUseStarRatings, selectedProduct) => {
  return shouldUseStarRatings && selectedProduct.reviewCount > 0;
};

const isGap = (abbrBrand, market) => {
  return GAP_BRANDS.includes(abbrBrand) && MARKETS.includes(market);
};

const brandReviewRatingsCount = (abbrBrand, selectedProduct, market) => {
  const reviewCountCheck =
    isGap(abbrBrand, market) &&
    selectedProduct.reviewCount < GAP_REVIEW_INITIAL_LIMIT;
  return reviewCountCheck ? false : true;
};

const getNormalizedColorSwatches = (colorSwatches) => {
  if (Array.isArray(colorSwatches)) {
    return colorSwatches;
  }
  return [];
};

const CategoryProductCard = ({
  cardIndex,
  cid,
  locale,
  pageIndex,
  pcid,
  productGridSource,
  productInfo,
  totalCount,
  hoverAlt,
  isQuickAddEnabled,
  highPriorityEvents,
  onFirstColorSwatchClick,
  onFirstCarouselArrowClick,
}: ProductCardProps) => {
  const { abbrBrand, market } = useContext(BrandInfoContext);
  const [selectedSwatch, setSelectedSwatch] = useState('');
  const [selectedProduct, setSelectedProduct] = useState(productInfo);
  const { localize } = useLocalize();
  const localizedNowText = localize(PRODUCT_GRID_REDUCED_PRICE_FLAG);
  const shouldUseStarRatings = useStarRatings();
  const showStarRatings = isStarRatingsEnabled(
    shouldUseStarRatings,
    selectedProduct
  );
  const reviewRatingLimit = brandReviewRatingsCount(
    abbrBrand,
    selectedProduct,
    market
  );
  const isColorSwatchesEnabled = useColorSwatches();
  const [hostUrl, setHostUrl] = useState('');

  const colorSwatches = getNormalizedColorSwatches(productInfo.swatchesProps);
  const selectedColorSwatch = isColorSwatchesEnabled
    ? colorSwatches.find((swatch) => swatch.selected)?.id
    : '';
  const isBRRedesignEnabled = useBRRedesign();
  const isDropshipEnabled = useDropship();

  useEffect(() => {
    const swatch = colorSwatches.find((swatch) => swatch.selected);
    if (swatch) {
      setSelectedProduct({
        ...productInfo,
        name: `${productInfo.name} ${
          swatch?.colorName ? swatch.colorName : ''
        }`,
      });
    }
    setSelectedSwatch(selectedColorSwatch);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productInfo.url]);
  const { minWidth, maxWidth, greaterOrEqualTo } =
    useContext(BreakpointContext);
  const isSmall = maxWidth(MEDIUM);
  const isMedium = minWidth(MEDIUM) && maxWidth(LARGE);
  const isLarge = greaterOrEqualTo(LARGE);
  const isXLarge = minWidth(XLARGE);

  const productHasPCID = (pcid) => {
    const { setItem } = storageHelper(sessionStorage);
    if (pcid != null) {
      setItem(SCROLLED_CID, pcid);
    }
  };

  const getProductUrl = (selectedProduct, productLink) => {
    return !selectedProduct.outOfStock && productLink;
  };

  const productLink = buildProductLink({
    pid: selectedProduct.productID,
    additionalQueryParams: selectedProduct.additionalQueryParams,
    cid: cid,
    pcid: pcid,
    vid: productInfo.vid,
    grid: {
      productGridSource: productGridSource,
      cardIndex: cardIndex,
      totalCount: totalCount,
      pageIndex: pageIndex,
    },
    nav: new URLSearchParams(getLocationSearch()).get('nav'),
    storeId: getHashParameter('storeId'),
  });

  const productUrl = getProductUrl(selectedProduct, productLink);

  const setScrollYPosition = () => {
    const { setItem } = storageHelper(sessionStorage);
    setItem(SCROLL_Y_POSITION, window.pageYOffset.toString());
  };

  const setStarRatingsClickEngagement = (type) => {
    const { setItem } = storageHelper(localStorage);
    if (showStarRatings) {
      setItem(
        `${RATINGS_ENGAGEMENT}-${selectedProduct.productID}`,
        JSON.stringify({
          type: type || 'product-image-click',
          average: selectedProduct.reviewScore,
        })
      );
    }
  };

  const handleProductClick = (event, type) => {
    try {
      productHasPCID(pcid);
      setScrollYPosition();
      setStarRatingsClickEngagement(type);
    } catch (err) {
      // sessionStorage not supported in Safari private mode prior to Version 11
    }
    return false;
  };

  const isDropshipProduct = () =>
    isDropshipEnabled && selectedProduct.dropshipData ? true : false;

  const getQucikAddDropshipProps = () => {
    return {
      isDropShipEnabled: isDropshipProduct(),
      sellerName: selectedProduct?.dropshipData?.vendorName,
    };
  };

  const getQuickAddFragment = (
    isQuickAddEnabled,
    selectedProduct,
    isBRRedesignEnabled
  ) => {
    return isQuickAddEnabled ? (
      <QuickAdd
        productId={selectedProduct.productID}
        productName={selectedProduct.productName}
        reviewCount={selectedProduct.reviewCount}
        starRating={selectedProduct.reviewScore}
        isBRRedesignEnabled={isBRRedesignEnabled}
        {...getQucikAddDropshipProps()}
      />
    ) : null;
  };

  const getStarRatingsFragment = ({
    showStarRatings,
    productLink,
    selectedProduct,
    handleProductClick,
    reviewRatingLimit,
  }) => {
    return showStarRatings && reviewRatingLimit ? (
      <StarReviewStyledWrapper
        onClick={(event) => handleProductClick(event, 'star-ratings-click')}
        href={productLink}
        isProductOutOfStock={productInfo.outOfStock}
      >
        <ReviewRatings
          reviewCount={selectedProduct.reviewCount}
          showNumberOnly
          starRating={selectedProduct.reviewScore}
        />
      </StarReviewStyledWrapper>
    ) : null;
  };

  const getProductMarketingFlagFragment = (productInfo) => {
    return !!productInfo.marketingFlag ? (
      <ProductMarketingFlag
        breakPoints={{ isSmall, isMedium, isLarge, isXLarge }}
        isBRRedesignEnabled={isBRRedesignEnabled}
        marketingFlag={productInfo.marketingFlag}
      />
    ) : null;
  };

  const handleSwatchChange = (event) => {
    const productID = event.currentTarget.id;
    const selectedColorSwatch = event.currentTarget.value;
    const name = event.currentTarget.dataset.altText;

    const selectedSwatchObj = colorSwatches.filter(
      (swatch) => swatch.id === selectedColorSwatch
    );

    if (selectedSwatchObj[0] && isDropshipEnabled) {
      productInfo.dropshipData.vendorName = selectedSwatchObj[0].vendorName;
      productInfo.dropshipData.isLowestPriceCC =
        selectedSwatchObj[0].isLowestPriceCC;
    }

    setSelectedSwatch(selectedColorSwatch);
    setSelectedProduct({ productID, name, ...event.currentTarget.dataset });
  };

  const getColorSwatchFragment = (isColorSwatchesEnabled) => {
    return isColorSwatchesEnabled ? (
      <Swatches
        colorArray={colorSwatches}
        onChange={handleSwatchChange}
        overflowBehavior={'carousel'}
        productUrl={productLink}
        radioGroupName={productLink}
        selected={selectedSwatch}
        onFirstColorSwatchClick={onFirstColorSwatchClick}
        onFirstCarouselArrowClick={onFirstCarouselArrowClick}
      />
    ) : null;
  };

  const quickAddFragment = getQuickAddFragment(
    isQuickAddEnabled,
    selectedProduct,
    isBRRedesignEnabled
  );

  const starRatingsFragment = getStarRatingsFragment({
    showStarRatings,
    productLink,
    selectedProduct,
    handleProductClick,
    reviewRatingLimit,
  });

  const productMarketingFlagFragment =
    getProductMarketingFlagFragment(productInfo);

  const colorSwatchFragment = getColorSwatchFragment(isColorSwatchesEnabled);
  const { mainImageSrc, hoverImageSrc } = useProductImagery(
    selectedProduct,
    cid
  );

  const getdropshipFragment = () => {
    return isDropshipEnabled && productInfo.dropshipData ? (
      <DropshipDetails dropshipData={productInfo.dropshipData} />
    ) : null;
  };
  const dropshipFragment = getdropshipFragment();

  const getPriceLineText = () => {
    return isDropshipEnabled && productInfo.dropshipData ? (
      <PriceLine dropshipData={productInfo.dropshipData} />
    ) : null;
  };
  const priceLineText = getPriceLineText();

  return (
    <ProductCard
      productInfo={selectedProduct}
      isBRRedesignEnabled={isBRRedesignEnabled}
    >
      {
        <ProductImage
          id={`product${selectedProduct.productID}`}
          alt={selectedProduct.altText}
          hoverAlt={hoverAlt}
          hoverSrc={hoverImageSrc}
          isBRRedesignEnabled={isBRRedesignEnabled}
          productUrl={productUrl}
          src={mainImageSrc}
          index={cardIndex}
          highPriorityEvents={highPriorityEvents}
          onClick={handleProductClick}
        >
          {quickAddFragment}
        </ProductImage>
      }
      {colorSwatchFragment}
      <ProductInfoWrapper
        breakPoints={{ isSmall, isMedium, isLarge, isXLarge }}
      >
        <ProductName
          clickable={!productInfo.outOfStock}
          name={selectedProduct.name}
          link={productLink}
          onClick={handleProductClick}
          isBRRedesignEnabled={isBRRedesignEnabled}
          breakPoints={{ isMedium, isSmall, isLarge, isXLarge }}
        />
        {starRatingsFragment}
        <ProductPriceWrapper
          breakPoints={{ isMedium, isSmall, isLarge, isXLarge }}
          isBRRedesignEnabled={isBRRedesignEnabled}
        >
          <PriceLineDiv>
            {priceLineText}
            <Price
              adapter={catPriceAdapter}
              brand={abbrBrand}
              locale={locale}
              localizedNow={localizedNowText}
              price={productInfo.price}
            />
          </PriceLineDiv>
        </ProductPriceWrapper>
        {productMarketingFlagFragment}
        {dropshipFragment}
      </ProductInfoWrapper>
    </ProductCard>
  );
};

export default CategoryProductCard;
